import { ethers } from "ethers";
import multicallAbi from '../json/multicall.json';
import StakeAbi from '../json/tokenstake.json';
import { getWeb3 } from "./functions";
import { CHAIN_INFO, DEFAULT_CHAIN } from "./constant";

export const getContract = (abi, address, library) => {
    try {
        return new ethers.Contract(address, abi, library)
    }
    catch {
        return false;
    }
}

export const getWeb3Contract = (abi, address) => {
    let web3 = getWeb3();
    return new web3.eth.Contract(abi, address);
}


export const getMultiCallContract = () =>{
  let web3 = getWeb3();
  return new web3.eth.Contract(multicallAbi, CHAIN_INFO[DEFAULT_CHAIN].multicall_address);
}


export const getStakingContract = (chainId) =>{
  let web3 = getWeb3();
  return new web3.eth.Contract(StakeAbi, CHAIN_INFO[DEFAULT_CHAIN].stake_address);
} 


export const getMultiCall = async (calls = []) => {
    let web3 = getWeb3();
    const mc = new web3.eth.Contract(multicallAbi, CHAIN_INFO[DEFAULT_CHAIN].multicall_address);
    const callRequests = calls.map((call) => {
      const callData = call.encodeABI();
      return {
        target: call._parent._address,
        callData,
      };
    });
  
    const { returnData } = await mc.methods
      .aggregate(callRequests)
      .call({});
  
    let finalData = returnData.map((hex, index) => {
      const types = calls[index]._method.outputs.map((o) =>
        o.internalType !== o.type && o.internalType !== undefined ? o : o.type
      );
  
      let result = web3.eth.abi.decodeParameters(types, hex);
  
      delete result.__length__;
  
      result = Object.values(result);
  
      return result.length === 1 ? result[0] : result;
    });
  
    return finalData;
  }